import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { LivePackageResponseEntity } from '../../domain/entities/LivePackageResponseEntity'
import type { GetStreamingPackagesV2AdminResponse } from '@/backend/market'
import { LivePackageEntity } from '../../domain/entities/LivePackageEntity'
import { LivePackageModel } from './LivePackageModel'

export class LivePackageStreamV2ResponseModel extends LivePackageResponseEntity {
  nextCursor?: string
  hasNextPage?: boolean

  constructor(dataDto: GetStreamingPackagesV2AdminResponse) {
    super()
    const livePackageModels = dataDto.data?.map((pkg) => new LivePackageModel(pkg as LivePackageEntity))
    this.nextCursor = dataDto.nextCursor || undefined
    this.hasNextPage = dataDto.hasNextPage || false
    
    mapEntityProperties<LivePackageResponseEntity>(
      this,
      dataDto as unknown as Partial<Record<keyof LivePackageResponseEntity, unknown>>,
      {
        map: {
          packages: livePackageModels
        }
      }
    )
  }
}
